"use client";

import { m as motion } from "framer-motion";
import { fadeInUp, defaultViewport, defaultTransition } from "@/lib/motion";

export const OurApproachSection = () => {
  return <div className="section-inner">
      <div className="text-center mb-16">
        <h2 className="text-3xl font-bold tracking-tighter sm:text-5xl mb-6 text-background">
          Our Approach
        </h2>
        <div className="max-w-3xl mx-auto space-y-4">
          <p className="text-lg md:text-xl text-background/90 max-w-[900px] mx-auto text-center">
            Our special blend of psychology with practical application
            makes learning how to leverage AI easier, more actionable, and more effective.
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-8 md:gap-12">
        <div className="grid grid-rows-[auto_1fr] h-full gap-8">
          <motion.h3
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={defaultViewport}
            transition={defaultTransition}
            className="text-2xl font-bold text-center md:text-left text-background"
          >
            Other Ways to Learn AI Skills
          </motion.h3>
          <div className="grid grid-rows-3 gap-8">
            {[
              { title: "In-the-weeds Technical Overview", desc: "Most AI training today focuses much of its time on the technical specifications, terms, and mechanics that are less relevant to HR and shift quickly." },
              { title: "Vague Terms and High-level Descriptions", desc: "AI in HR training starts and stops with PowerPoints, term glossaries, and could/would/should statements about AI, not hands-on skills developed by building." },
              { title: "One-and-done Demos and Workshops", desc: "Today, learners are overwhelmed with narrow, single use tutorials that have a limited impact on workflows and employees." },
            ].map((item, i) => (
              <motion.div
                key={item.title}
                initial={{ x: -15, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                viewport={defaultViewport}
                transition={{ ...defaultTransition, delay: 0.1 * (i + 1) }}
                className="card-contrast border-l-4 border-red-500 hover:shadow-depth-xl"
              >
                <h4 className="text-xl font-bold mb-3">{item.title}</h4>
                <p className="opacity-80 flex-grow leading-relaxed">{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>

        <div className="grid grid-rows-[auto_1fr] h-full gap-8">
          <motion.h3
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={defaultViewport}
            transition={defaultTransition}
            className="text-2xl font-bold text-center md:text-left text-background"
          >
            Our Way
          </motion.h3>
          <div className="grid grid-rows-3 gap-8">
            {[
              { title: "Research-Based Frameworks", desc: "Drawing from tech adoption, workplace psychology, and computer science research, we've built an adoption framework that gets your team excited about AI." },
              { title: "Hands-on Tutorials and Coaching", desc: "Learning AI on your own can be time-consuming and frustrating. Our hands-on demos and support will boost your confidence, and our Slack community will connect you to a growing network of AI-enabled HR consultants and practitioners." },
              { title: "A Clear Action Plan", desc: "Our materials and coaching will help you scale. We won't leave you with access to new tools or systems without a plan for making sure they provide high-impact, high-margin results that grow with your organization." },
            ].map((item, i) => (
              <motion.div
                key={item.title}
                initial={{ x: 15, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                viewport={defaultViewport}
                transition={{ ...defaultTransition, delay: 0.1 * (i + 1) }}
                className="card-contrast border-l-4 border-green-500 hover:shadow-depth-xl"
              >
                <h4 className="text-xl font-bold mb-3">{item.title}</h4>
                <p className="opacity-80 flex-grow leading-relaxed">{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>;
};
